import { isValidPhoneNumber } from 'libphonenumber-js';
import { BodyText, Avatar, Icon } from '@servicetitan/design-system';
import maskPhoneNumber from '@lib/utils/maskPhoneNumber';
import styles from './TransferringCallConfirmation.module.css';
import { ITransferringCallItem } from '../context';
import { OutboundCallEntity } from '@lib/types/common-call-types';
import { FeatureFlagKeys, useFeatureFlags } from '@modules/FeatureFlagModule';
import classNames from 'classnames';

interface TransferringCallItemProps {
  item: ITransferringCallItem;
  transferType?: OutboundCallEntity;
}

export const TransferringCallItem: React.FC<TransferringCallItemProps> = ({
  item,
  transferType,
}) => {
  const {
    [FeatureFlagKeys.featureInboxCallTransferToQueue]:
      featureInboxCallTransferToQueue,
  } = useFeatureFlags();
  const isTransferringToQueue =
    featureInboxCallTransferToQueue &&
    transferType === OutboundCallEntity.Queue;

  const number = maskPhoneNumber(item?.number);

  if (item?.name && !isValidPhoneNumber(item.name)) {
    return (
      <div className={styles.item}>
        <div className={styles.iconBox}>
          <Avatar name={item.name} />
        </div>
        <BodyText className={classNames(styles.bold, styles.bodyTextElipsis)}>
          {item.name}
        </BodyText>
        {!isTransferringToQueue && (
          <BodyText size='small' className={styles.secondaryText}>
            {number}
          </BodyText>
        )}
      </div>
    );
  }

  return (
    <div className={styles.item}>
      <div className={styles.iconBox}>
        <Icon name='local_phone' size={24} />
      </div>
      <BodyText className={styles.primaryText}>{number}</BodyText>
    </div>
  );
};
